import { Component, OnInit, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { AbsencesRest } from '../absences.rest';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { AbsenceHeaderComponent } from './absence-header/absence-header.component';
import { Absence, AbsenceAction, AbsenceCurrentUser, AbsenceNotificationEmployee } from '../absences.model';
import { MatTabChangeEvent } from '@angular/material';
import { AbsenceHistoryComponent } from './absence-history/absence-history.component';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { EmployeeIdSelectionComponent } from '../../core/shared/employee-selection/employee-id-selection.component';

@Component({
  selector: 'app-absence-details',
  templateUrl: './absence-details.component.html',
  styleUrls: ['./absence-details.component.scss']
})
export class AbsenceDetailsComponent implements OnInit, HasPermissions, AfterViewInit {
  public absence: Absence;
  public isNew = false;
  public viewEnabled = false;

  private currentUser: AbsenceCurrentUser;
  private isSaving = false;
  private selectedTab = 1

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private rest: AbsencesRest,
    private permissionsService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService
  ) {
  }

  private menuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false }
    //{ text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false };

  permissions: Permissions;

  @ViewChild(AbsenceHeaderComponent) absenceHeaderComponent: AbsenceHeaderComponent;
  @ViewChild(AbsenceHistoryComponent) absenceHistoryComponent: AbsenceHistoryComponent;
  @ViewChild("notificationEmployeesGrid") notificationEmployeesGrid: GridComponent;
  @ViewChild("employeeselection") public employeeSelectionModal: EmployeeIdSelectionComponent;

  private notificationsHeaders = [
    { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
    { displayName: 'Imię', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Nazwisko', propertyName: 'surname', propertyType: 'string' }
  ];

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.save();
    event.preventDefault();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('Absence');

    if (this.permissions.canAdd || this.permissions.canEdit) {
      this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = true;
      this.saveButton.enabled = true;
    }
    this.route.queryParams.subscribe(params => {
      this.spinnerService.show();
      if (params.id !== undefined) {
        let absenceId = parseInt(params.id);
        this.isNew = false;
        this.rest.getAbsence(absenceId).subscribe(absence => {
          this.absence = absence;
          this.getAbsenceCurrentUser();
          this.spinnerService.hide();
        });
      }
      else {
        this.isNew = true;
        this.rest.getEmptyAbsence().subscribe(absence => {
          this.absence = absence;
          this.getAbsenceCurrentUser();
          this.spinnerService.hide();
        });
      }
    });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.index === 1) {
      if (this.absence.history) {
        const lastElement = this.absence.history.sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime())[this.absence.history.length - 1];
        if (lastElement) {
          this.absence.absenceStateInternalName = lastElement.stateInternalName;
        }
      }
    }
    if (tabChangeEvent.index === 2) {
      if (this.absence.history == undefined) {
        this.spinnerService.show();
        this.rest.getAbsenceHistory(this.absence.id).subscribe(absenceHistory => {
          this.absence.history = absenceHistory;

          this.absenceHistoryComponent.setModel(this.absence);
          this.spinnerService.hide();
        });
      } else {
        this.absenceHistoryComponent.setModel(this.absence);
      }
    }
  }

  save() {
    if (this.absenceHeaderComponent.isInvalid()) {
      sweetAlert('Dane są niekompletne, nie można zapisać');
      return;
    }
    this.saveAbsence();
  }

  close() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  changeState(state: AbsenceAction, withInit: boolean = true) {
    if (this.absenceHeaderComponent.isInvalid()) {
      sweetAlert('Dane są niekompletne, nie można zapisać');
      return;
    }
    this.spinnerService.show();
    this.rest.saveAbsence(this.absence, withInit).subscribe((result: number) => {
      if (result) {
        this.rest.changeAbsenceState(result, state, this.currentUser.employeeId).subscribe(result => {
          if (result) {
            this.close();
          }
          this.spinnerService.hide();
        });
      }
    });
  }

  getAbsenceCurrentUser() {
    this.spinnerService.show();
    this.rest.getAbsenceCurrentUser(this.absence.employeeId).subscribe((result: AbsenceCurrentUser) => {
      if (result) {
        this.currentUser = result;
        this.absenceHeaderComponent.setModel(this.absence, this.isNew, this.permissions, this.currentUser);
        this.addButtons();
      }
      this.spinnerService.hide();
    });
  }

  private addButtons() {
    if (this.permissions.canEdit) {
      var canDelete = this.permissions.canDelete && this.absence.absenceStateInternalName == 'Buffered';
      var canConfirm = this.permissions.canEdit && (this.absence.employeeId == this.currentUser.employeeId || this.absence.reporterId == this.currentUser.employeeId) && (this.absence.absenceStateInternalName == "Buffered" || this.absence.absenceStateInternalName === null);
      var canCancel = this.permissions.canEdit && (this.absence.employeeId === this.currentUser.employeeId || this.absence.reporterId === this.currentUser.employeeId || this.currentUser.isSupervisor) && ["ToBeConfirmed", "Accepted"].includes(this.absence.absenceStateInternalName);
      var canApprove = this.permissions.canEdit && this.currentUser.isSupervisor && this.absence.absenceStateInternalName == 'ToBeConfirmed';
      var canReject = this.permissions.canEdit && this.currentUser.isSupervisor && this.absence.absenceStateInternalName == 'ToBeConfirmed';

      this.menuButtons.push(
        { text: 'Do potwierdzenia', class: "btn-primary", icon: '', onClick: () => { this.changeState(AbsenceAction.Confirm, false); }, enabled: canConfirm, isForSelected: false }
      )
      this.menuButtons.push(
        { text: 'Potwierdź', class: "btn-primary", icon: '', onClick: () => { this.changeState(AbsenceAction.Approve); }, enabled: canApprove, isForSelected: false }
      )
      this.menuButtons.push(
        { text: 'Odrzuć', class: "btn-warning", icon: '', onClick: () => { this.changeState(AbsenceAction.Reject); }, enabled: canReject, isForSelected: false }
      )
      this.menuButtons.push(
        { text: 'Anuluj', class: "btn-warning", icon: '', onClick: () => { this.changeState(AbsenceAction.Cancel); }, enabled: canCancel, isForSelected: false }
      )
      this.menuButtons.push(
        { text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
      )
    }
  }

  private saveAbsence() {
    if (this.isSaving) {
      return;
    }
    const action = this.rest.saveAbsence;
    action.call(this.rest, this.absence, this.isNew).subscribe((result: number) => {
      if (this.isNew) {
        this.gridParamsRestoringService.saveAddingNewRowInfo(result);
      }
      this.isSaving = false;
      this.close();
    }, (error) => {
      this.isSaving = false;
    });
  }

  private addNotificationEmployee() {
    const action = this.rest.getEmployeesToSelect;
    action.call(this.rest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        let employeeIds = this.absence.notificationEmployees.map(x => x.notificationEmployeeId);
        if (this.absence.employeeId != 0)
          employeeIds.push(this.absence.employeeId)
        this.employeeSelectionModal.selectEmployee(result, employeeIds);
      }
    });
  }

  private removeNotificationEmployee(row: AbsenceNotificationEmployee) {
    let message = `Czy na pewno usunąć przypisanie pracownika powiadamianego ${row.name}?`;
    sweetAlert(message, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    }).then((value) => {
      switch (value) {
        case "yes":
          if (row.id > 0) {
            this.rest.removeNotificationEmployee(row.id).subscribe((result: boolean) => {
              if (result) {
                this.absence.notificationEmployees.splice(this.absence.notificationEmployees.indexOf(row), 1);
                this.notificationEmployeesGrid.refreshData();
              }
            });
          }
          else {
            this.absence.notificationEmployees.splice(this.absence.notificationEmployees.indexOf(row), 1);
            this.notificationEmployeesGrid.refreshData();
          }
          break;
      }
    });
  }

  private onEmployeeSelectionSuccess(event: { isSuccess: boolean, selectedEmployeeId: any }) {
    if (event.isSuccess) {
      this.rest.addNotificationEmployee(event.selectedEmployeeId, this.absence.id).subscribe((result: AbsenceNotificationEmployee) => {
        if (result) {
          this.absence.notificationEmployees.push(result);
          this.notificationEmployeesGrid.refreshData();
        }
      });
    }
  }
}
